import {
  WarrantyDescriptionSection,
  WarrantyPartsSection,
  WarrantyProductSection,
  WarrantyUserInfoSection,
  WarrantyWorkListSection,
} from '@components';
import { Divider } from '@mui/material';

export const WarrantyCreateForm = () => {
  return (
    <>
      <WarrantyUserInfoSection />
      <Divider sx={{ my: 4 }} />
      <WarrantyProductSection />
      <Divider sx={{ my: 4 }} />
      <WarrantyDescriptionSection />
      <Divider sx={{ my: 4 }} />
      <WarrantyPartsSection />
      <Divider sx={{ my: 4 }} />
      <WarrantyWorkListSection />
    </>
  );
};
